import {
    get
} from "@/common/request"

export function GetProductsData() {
    return get("product/get")
}